import React from "react";

export default function ProductDropdowns({
    formData,
    handleChange,
    categories,
    subCategories,
    states,
    cities,
    locations,
    amenities,
    setFormData,
}) {
    return (
        <>
            <div className="mb-3">
                <label className="form-label">Category</label>
                <select
                    name="category_id"
                    className="form-select"
                    value={formData.category_id}
                    onChange={handleChange}
                >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="mb-3">
                <label className="form-label">Sub Category</label>

                <select name="subcategory_id" className="form-select" onChange={handleChange}>
                    <option value="">Select Sub Category</option>
                    {subCategories.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">State</label>
                <select name="state_id" className="form-select" onChange={handleChange}>
                    <option value="">Select State</option>
                    {states.map((s) => (
                        <option key={s.id} value={s.id}>
                            {s.name}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <label className="form-label">City</label>
                <select name="city_id" className="form-select" onChange={handleChange}>
                    <option value="">Select City</option>
                    {cities.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="form-label">Location</label>
                <select name="location_id" className="form-select" onChange={handleChange}>
                    <option value="">Select Location</option>
                    {locations.map((l) => (
                        <option key={l.id} value={l.id}>
                            {l.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Choose Amenities</label>

                <div className="d-flex flex-wrap gap-2">
                    {amenities.map((a) => (
                        <div
                            key={a.id}
                            className="form-check border p-2 rounded"
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formData.amenities.includes(a.id)}
                                onChange={() => {
                                    const updated = formData.amenities.includes(a.id)
                                        ? formData.amenities.filter((i) => i !== a.id)
                                        : [...formData.amenities, a.id];

                                    setFormData((p) => ({
                                        ...p,
                                        amenities: updated,
                                    }));
                                }}
                            />

                            <label className="form-check-label ms-2">
                                {a.name}
                            </label>
                        </div>
                    ))}
                </div>
            </div>

        </>
    );
}